import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import '../../layout-position/types/index.esm.js';
import { EGDSLayoutPosition } from '../../layout-position/layout-position/index.esm.js';
import { EGDSLoader } from '../../loader/loader/index.esm.js';
import '../../loader/loader-container/index.esm.js';
import '../../loader/page-loader/index.esm.js';
import { EGDSScrim } from '../../scrim/scrim/index.esm.js';
import { EGDSScrimType } from '../../scrim/types/index.esm.js';
import { PlayerState } from '../types/index.esm.js';
const EGDSVideoLayerLoading = ({
  className,
  playerState
}) => {
  const {
    formatText
  } = useLocalization();
  return jsxs(Fragment, {
    children: [playerState === PlayerState.UNSTARTED ? jsx(EGDSScrim, {
      type: EGDSScrimType.OVERLAY
    }) : null, jsx(EGDSLayoutPosition, {
      className: className,
      type: "absolute",
      position: {
        top: 'center',
        left: 'center'
      },
      children: jsx(EGDSLoader, {
        isDarkBackground: true,
        title: formatText('video.loading.title')
      })
    })]
  });
};
export { EGDSVideoLayerLoading };